<template>
  <div id="welcome-container">
    <h1>
      Estou em dia com os
      <br />
      <b>meus exames</b>?
    </h1>
    <h4>Descubra se há exames Hilab recomendados para você.</h4>
    <p>
      Vale lembrar que os exames recomendados não exigem obrigatoriedade de realização.
      <br />
      <br />Exames de rotina devem ser realizados regularmente. Não deixe de consultar seu médico e estar sempre em dia com a sua saúde.
    </p>
    <v-form class="identification-form">
      <v-text-field
        class="name-text-field"
        required
        v-model="name"
        v-if="!hadName"
        :error-messages="nameErrors"
        label="NOME COMPLETO"
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"
      ></v-text-field>
      <v-text-field
        class="document-text-field"
        required
        v-model="document"
        v-if="!hadDocument"
        :error-messages="documentErrors"
        mask="###.###.###-##"
        label="CPF"
        placeholder="_ _ _ . _ _ _ . _ _ _ - _ _"
        @input="$v.document.$touch()"
        @blur="$v.document.$touch()"
      ></v-text-field>
      <v-text-field
        class="document-text-field"
        required
        v-model="email"
        v-if="!hadEmail"
        :error-messages="emailErrors"
        label="E-MAIL"
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
      ></v-text-field>
      <v-btn @click="submit()">INICIAR TESTE</v-btn>
    </v-form>
    <br />
  </div>
</template>

<script>
import router from "../router";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    name: { required, minLength: minLength(3) },
    document: { required, minLength: minLength(14) },
    email: { required, minLength: minLength(3) }
  },
  data() {
    return {
      name: "",
      document: "",
      email: "",
      hadName: false,
      hadDocument: false,
      hadEmail: false
    };
  },
  created() {
    this.name = this.$route.query.name;
    this.document = this.$route.query.document;
    this.email = this.$route.query.email;

    this.hadName = Boolean(this.name);
    this.hadDocument = Boolean(this.document);
    this.hadEmail = Boolean(this.email);

    sessionStorage.removeItem("mainExamName");
    sessionStorage.removeItem("mainExamDetails");
    sessionStorage.removeItem("recommendationsAmount");
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.nameErrors.length == 0 && this.documentErrors.length == 0) {
        sessionStorage.setItem("name", this.name);
        sessionStorage.setItem("document", this.document);
        sessionStorage.setItem("email", this.email);
        router.push("responder");
      }
    },
    validateCPF() {
      var sum = 0;
      var remainder;

      var cpf = this.document
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .trim();

      var allEqual = true;
      for (var i = 0; i < cpf.length - 1; i++) {
        if (cpf[i] != cpf[i + 1]) allEqual = false;
      }
      if (allEqual) return false;

      for (i = 1; i <= 9; i++)
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      remainder = (sum * 10) % 11;

      if (remainder == 10 || remainder == 11) remainder = 0;
      if (remainder != parseInt(cpf.substring(9, 10))) return false;

      sum = 0;
      for (i = 1; i <= 10; i++)
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      remainder = (sum * 10) % 11;

      if (remainder == 10 || remainder == 11) remainder = 0;
      if (remainder != parseInt(cpf.substring(10, 11))) return false;

      return true;
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("Campo obrigatório");
      !this.name.includes(" ") && errors.push("Insira o nome completo");
      return errors;
    },
    documentErrors() {
      const errors = [];
      if (!this.$v.document.$dirty) return errors;
      !this.$v.document.required && errors.push("Campo obrigatório");

      if (this.document) {
        if (!this.validateCPF()) {
          errors.push("Insira um documento válido");
        }
      }

      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Campo obrigatório");
      !this.email.includes("@") && errors.push("Insira um email válido");

      return errors;
    }
  }
};
</script>

<style lang="scss">
.identification-form {
  display: inline-flex;
  table-layout: auto;
  margin-top: 40px;
  width: 80%;
  div {
    padding-right: 5px;
  }
}
.name-text-field {
  width: 50%;
}
.document-text-field {
  width: 30%;
}

#welcome-container {
  .v-text-field {
    color: #00bcb0 !important;
    margin-bottom: 20px;

    .v-label--active {
      transform: translateY(-35px) scale(0.75);
      margin-left: 0px;
      color: #00bcb0 !important;
    }
  }
}
.v-input__slot {
  border: none !important;
  border-style: none !important;
}
.v-input__slot::before {
  border-color: #ffffff00 !important;
}
.v-text-field__slot {
  input {
    margin: 0 auto;
    padding-left: 10px;
    padding-right: 10px;
    max-height: none;
    margin-bottom: 0;
  }
  label {
    line-height: 32px !important;
    height: 32px !important;
    margin-left: 10px;
  }
  height: 44px;
  background: #efefef;
  border-radius: 4px;
}
input[type="text"] {
  border-bottom: none !important;
  box-shadow: none !important;
}

#welcome-container {
  padding-top: 120px;
  padding-bottom: 160px;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 1280px;
  margin: auto auto;
  color: white;
  font-family: Muli;
  text-align: left;

  h1 {
    font-family: Yanone Kaffeesatz;
    max-width: 50%;
  }
  h4 {
    font-weight: 700;
    font-size: 21px;
    max-width: 50%;
  }

  p {
    margin-top: 40px;
    font-size: 16px;
    max-width: 80%;
  }

  button {
    display: block;
    height: 45px;
    font-weight: 700;
    font-size: 14px;
    border-radius: 4px;
    margin: auto auto;
    color: white;
    margin-top: 15px;
    background-color: #00bfb3;

    div {
      margin: 0 0;
      width: auto;
    }
  }
}

@media (max-width: 991px) {
  .identification-form {
    display: initial;
    padding-top: 40px;

    .v-text-field {
      max-width: 400px;
      width: 100%;
      margin: auto auto;
    }
  }
  #welcome-container {
    h1 {
      font-size: 23px;
      max-width: 100%;
    }
    h4 {
      font-size: 14px;
      max-width: 100%;
    }

    p {
      font-size: 12px;
      max-width: 100%;
      padding-bottom: 20px;
    }

    button {
      display: block;
      height: 45px;
      font-weight: 700;
      font-size: 14px;
      border-radius: 4px;
      margin: auto auto;
      color: white;
      margin-top: 15px;
      background-color: #00bfb3;

      div {
        margin: 0 0;
        width: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserIdentification.vue